import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
export function CtaBand() {
  return <section className="bg-flame text-ink" data-id="element-160" data-mp="2wh8m0hu2iuv4">
      <div className="mx-auto flex max-w-[1320px] flex-col items-center gap-8 px-5 py-16 text-center md:flex-row md:items-end md:justify-between md:px-8 md:py-24 md:text-left" data-id="element-161" data-mp="2ihziahn1tt81">
        <div className="max-w-2xl" data-id="element-162" data-mp="2nj6q2gp6ysep">
          <h2 className="font-display text-5xl font-bold uppercase leading-[0.9] md:text-7xl" data-id="element-163" data-mp="28ro0psafzlio">
            Have a Specification Ready?
          </h2>
          <p className="mt-5 text-lg font-medium md:text-xl" data-id="element-164" data-mp="2dk7hey4fewrp">
            Send it to us and we will come back with the right material and a quotation.
          </p>
        </div>
        <Link to="/contact" className="inline-flex h-14 w-full shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-ink px-9 font-bold uppercase tracking-[0.06em] text-chalk transition-colors duration-150 hover:bg-coal sm:w-auto" data-id="element-165" data-mp="24rdz0rtonh9m">
          Request a Quote
          <ArrowUpRightIcon className="h-5 w-5 text-flame" aria-hidden="true" data-id="element-166" data-mp="qp78doxsczhb" />
        </Link>
      </div>
    </section>;
}